import { mergeAttributes, Node } from '@tiptap/react'

/**
 * El backend sustituye los campos buscando literalmente
 * `<a href="https://dalala.app/" class="wysiwyg-mention" data-mention data-value="X">@X</a>`
 * (formato de react-draft-wysiwyg); este nodo debe producir exactamente ese HTML.
 */
export const MENTION_HREF = 'https://dalala.app/'
export const MENTION_CLASS = 'wysiwyg-mention'
export const MENTION_NODE = 'correoMention'

export const EmailTemplateMention = Node.create({
    name: MENTION_NODE,
    group: 'inline',
    inline: true,
    atom: true,
    selectable: true,

    addAttributes() {
        return {
            value: {
                default: '',
                parseHTML: (element) => element.getAttribute('data-value') || '',
                renderHTML: () => ({}),
            },
        }
    },

    parseHTML() {
        return [{ tag: 'a[data-mention]', priority: 1000 }]
    },

    renderHTML({ node, HTMLAttributes }) {
        const value = String(node.attrs.value || '')
        return [
            'a',
            mergeAttributes({ href: MENTION_HREF, class: MENTION_CLASS, 'data-mention': '', 'data-value': value }, HTMLAttributes),
            `@${value}`,
        ]
    },

    renderText({ node }) {
        return `@${node.attrs.value}`
    },

    /** Dentro del editor se pinta como `<span>` para que el clic no siga el enlace; `getHTML()` sigue usando `renderHTML`. */
    addNodeView() {
        return ({ node }) => {
            const dom = document.createElement('span')
            dom.className = MENTION_CLASS
            dom.setAttribute('data-value', String(node.attrs.value || ''))
            dom.contentEditable = 'false'
            dom.textContent = `@${node.attrs.value}`
            return { dom }
        }
    },
})

/** ProseMirror serializa el atributo vacío como `data-mention=""`; el backend espera `data-mention`. */
export const normalizeMentionHtml = (html: string) => html.replace(/ data-mention=""/g, ' data-mention')
